import { DateTime } from 'luxon';

export default function useHasExpired(endDate) {
  const diff = DateTime.now().diff(DateTime.fromISO(endDate)).as('days');

  return endDate && diff > 0;
};
